import pushToDataLayer from "./pushToDataLayer";

const notificationsOptInResponseEvent = (
  ctaResponseType,
  ctaResponseName = "marketing_opt_in"
) => {
  pushToDataLayer({
    cta_response: {
      cta_response_type: ctaResponseType,
      cta_response_name: ctaResponseName,
      cta_reference: "saved_items_marketing_opt_in"
    }
  });
};

export default notificationsOptInResponseEvent;
